
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { PlanRequest } from "../../domain/requests/plans/plan.request";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class AddPlanUsecase implements UseCase<PlanRequest, string> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: PlanRequest): Observable<string> {
    return this.planRepository.addPlan(params);
  }

}
